export default __webpack_public_path__ + "static/media/logo3.8c995c40.svg";